import { AdminFilters } from '#components/adminFilters/AdminFiltersPanel.js'
import { FilterInput } from '#components/adminFilters/FilterInput.js'
import { FilterRow } from '#components/adminFilters/FilterRow.js'
import { FilterSelect } from '#components/adminFilters/FilterSelect.js'
import { ScacTypeahead } from '#components/ScacTypeahead.js'
import { getRangeOptions, type RangeKey } from '#utils/timeRanges'

import { TraceFilterInput } from './TraceFilterInput'
import { type TracesFilters } from './tracesFilters'
import { TRACE_SERVICES } from './traceUtils'

interface TracesFilterFormProps {
  value: TracesFilters
  onChange: (value: TracesFilters) => void
  isLoading: boolean
  onRefresh: () => void
}

export const TracesFilterForm = ({
  value,
  onChange,
  isLoading,
  onRefresh,
}: TracesFilterFormProps) => {
  const handleChange = <Key extends keyof TracesFilters>(
    key: Key,
    fieldValue: TracesFilters[Key],
  ) => onChange({ ...value, [key]: fieldValue })

  return (
    <AdminFilters isLoading={isLoading} onRefresh={onRefresh}>
      <FilterRow>
        <FilterInput
          label="Trace ID"
          value={value.traceId}
          onChange={traceId => handleChange('traceId', traceId)}
          placeholder="Ignores the other filters when set"
        />
        <ScacTypeahead
          value={value.carrier}
          onChange={carrier => handleChange('carrier', carrier)}
        />
        <FilterSelect
          label="Layer"
          value={value.service}
          onChange={service => handleChange('service', service)}
          options={[
            { value: '', label: 'All' },
            ...TRACE_SERVICES.map(service => ({
              value: service,
              label: service,
            })),
          ]}
        />
        <FilterSelect
          label="Status"
          value={value.status}
          onChange={status =>
            handleChange('status', status as TracesFilters['status'])
          }
          options={[
            { value: '', label: 'All' },
            { value: 'error', label: 'Error' },
            { value: 'success', label: 'Success' },
          ]}
        />
        <FilterSelect
          label="Time range"
          value={value.range}
          onChange={range => handleChange('range', range as RangeKey)}
          options={getRangeOptions().filter(o => o.value !== 'all')}
        />
        {value.range === 'custom' ? (
          <>
            <FilterInput
              label="From"
              value={value.customFrom}
              onChange={customFrom => handleChange('customFrom', customFrom)}
              type="datetime-local"
            />
            <FilterInput
              label="To"
              value={value.customTo}
              onChange={customTo => handleChange('customTo', customTo)}
              type="datetime-local"
            />
          </>
        ) : null}
      </FilterRow>
      <FilterRow>
        <TraceFilterInput
          value={value.filter}
          onApply={filter => handleChange('filter', filter)}
        />
      </FilterRow>
    </AdminFilters>
  )
}
